<template>
    <img v-if="isDark" class="position-relative" src="../../assets/history.svg" alt="history" />
    <img v-else-if="isGrey" class="position-relative" src="../../assets/historyGrey.svg" alt="history" />
    <img v-else class="position-relative" src="../../assets/historyLight.svg" alt="history" />
</template>
<style lang="scss" scoped>
@media (max-width: 1440px) {
    img {
        width: 35px !important;
    }
}
</style>
<script>
export default {
    props: {
        isDark: {
            type: Boolean,
            required: false,
            default: true
        },
        isGrey: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>



// WEBPACK FOOTER //
// HistoryIcon.vue?78a5086f